import { Dropdown } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logoutUser } from "../redux/auth/actions";

function toggleOffcanvas() {
  document.querySelector(".sidebar-offcanvas").classList.toggle("active");
}

function toggleRightSidebar() {
  document.querySelector(".right-sidebar").classList.toggle("open");
}

const Navbar = () => {
  const dispatch = useDispatch();
  const Navigate = useNavigate()
  const { t } = useTranslation()
  const authState = useSelector((state) => state.Auth);
  const profileState = useSelector((state) => state.Profile);

  return (
    <div>
      <nav className="navbar p-0 fixed-top d-flex flex-row">
        <button
          className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
          type="button"
          onClick={toggleOffcanvas}
        >
          <span className="mdi mdi-format-line-spacing"></span>
        </button>
        <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
          <Link className="navbar-brand brand-logo-mini" to="/">
            <img
            src={`${profileState.profile?.logo != null ? profileState.profile?.logo.file_secure_url : ""}`}
            alt="logo" />
          </Link>
        </div>
        <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
          <button
            className="navbar-toggler align-self-center"
            type="button"
            onClick={() => document.body.classList.toggle("sidebar-icon-only")}
          >
            <span className="mdi mdi-menu"></span>
          </button>

          <ul className="navbar-nav navbar-nav-right">
            {/* <Dropdown alignRight as="li" className="nav-item d-none d-lg-block">
              <Dropdown.Toggle className="nav-link btn btn-success create-new-button no-caret">
                + <Trans>Create New Project</Trans>
              </Dropdown.Toggle>

              <Dropdown.Menu className="navbar-dropdown preview-list create-new-dropdown-menu">
                <h6 className="p-3 mb-0">
                  <Trans>Projects</Trans>
                </h6>
                <Dropdown.Divider />
                <Dropdown.Item
                  href="!#"
                  onClick={(evt) => evt.preventDefault()}
                  className="preview-item"
                >
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-file-outline text-primary"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">
                      <Trans>Software Development</Trans>
                    </p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  href="!#"
                  onClick={(evt) => evt.preventDefault()}
                  className="preview-item"
                >
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-web text-info"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">
                      <Trans>UI Development</Trans>
                    </p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  href="!#"
                  onClick={(evt) => evt.preventDefault()}
                  className="preview-item"
                >
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-layers text-danger"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject ellipsis mb-1">
                      <Trans>Software Testing</Trans>
                    </p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <p className="p-3 mb-0 text-center">
                  <Trans>See all projects</Trans>
                </p>
              </Dropdown.Menu>
            </Dropdown> */}
            <Dropdown as="li" className="nav-item">
              <Dropdown.Toggle
                as="a"
                className="nav-link cursor-pointer no-caret"
              >
                <div className="navbar-profile">
                  {/* {profileState.profile?.logo.file_secure_url ? (
                    <img
                      className="img-xs rounded-circle"
                      src={`./images/company_profile/${profileState.profile?.logo.file_secure_url}`}
                      alt="profile"
                    />
                  ) : ( */}
                    <div className="badge profile-badge img-xs rounded-circle badge-primary">
                      {authState?.profile
                        ? `${authState?.profile?.firstName
                            .charAt(0)
                            .toUpperCase()}${authState?.profile?.lastName
                            .charAt(0)
                            .toUpperCase()}`
                        : ""}
                    </div>
                  {/* )} */}

                  <p className="mb-0 d-none d-sm-block navbar-profile-name">
                    {authState?.profile?.firstName.toUpperCase() +
                      " " +
                      authState?.profile?.lastName.toUpperCase()}
                  </p>
                  <i className="mdi mdi-menu-down d-none d-sm-block"></i>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="navbar-dropdown preview-list navbar-profile-dropdown-menu"
                style={{
                  position: "absolute",
                  inset: "0px 0px auto auto",
                  marginTop: "9px",
                  transform: "translate3d(-28px, 71px, 0px)",
                }}
              >
                <h6 className="p-3 mb-0">
                  <Trans>Profile</Trans>
                </h6>
                <Dropdown.Divider />
                <Dropdown.Item
                  // href="!#"
                  onClick={() => Navigate("/company-profile")}
                  className="preview-item"
                >
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-settings text-success"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">
                      <Trans>{t("account_setup")}</Trans>
                    </p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                  // href="!#"
                  onClick={() => dispatch(logoutUser())}
                  className="preview-item"
                >
                  <div className="preview-thumbnail">
                    <div className="preview-icon bg-dark rounded-circle">
                      <i className="mdi mdi-logout text-danger"></i>
                    </div>
                  </div>
                  <div className="preview-item-content">
                    <p className="preview-subject mb-1">
                      <Trans>{t("logout")}</Trans>
                    </p>
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
              </Dropdown.Menu>
            </Dropdown>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
